import { Loading } from "@mnk/frontend/components/Loading";
import { SideMenu } from "../../../components/pages/settings/sideMenu";
import { UsersList } from "../../../components/pages/settings/users/List";
import { trpc } from "../../../lib/trpc";
import { NotFound } from "../../NotFound";

export const UsersSetting = () => {
  const getUser = trpc.getUser.useQuery();
  const user = getUser.data;

  if (getUser.isLoading) return <Loading />;
  if (user?.role !== "admin") return <NotFound />;

  return (
    <div className="flex max-w-[1080px] mx-auto pt-8 px-4">
      <SideMenu />
      <UsersList />
    </div>
  );
};
